import Introduction from "../../../../content/gettingStarted/introduction.md";
import * as React from 'react';
export default {
  Introduction,
  React
};